import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import API from "../../libs/API.js";
import { getText } from "../../libs/utils.js";
import { CloseIcon, CancelIcon } from "../../assets/images/icons.jsx";



export default function CancelOrder({ orderCode, updateCallback, ...props }) {
  const [open, setOpen] = useState(false);


  const cancelOrder = () => {
    API.cancelOrder(orderCode).then(data => {
      if (data.success) {
        setOpen(false);
        updateCallback();
      } else {
        window.showMessage(data.data[0].message);
      }
    });

  }

  return (
    <React.Fragment>
      <Button
        variant="contained" sx={{
          padding: '15px 31px',
          display: 'flex',
          gap: '8px',
        }} color="warning" onClick={() => setOpen(true)} ><CancelIcon />{getText("payCancelBtn")}</Button>
      <Dialog PaperProps={{
        sx: {
          minWidth: '340px',
          width: '340px',
          padding: '24px 24px 24px 24px',
          textAlign: 'center',
          borderRadius: '20px',
        }
      }} open={open} onClose={() => setOpen(false)} >
        <CloseIcon style={{ position: 'absolute', right: 12, top: 12, cursor: 'pointer' }} onClick={() => setOpen(false)} />
        <DialogTitle variant="h4" color="primary" sx={{
          marginBottom: '0px',
          fontSize: '22px',
          paddingBottom: '8px',
        }}>{getText("payCancelTitle")}</DialogTitle>
        <DialogContent sx={{
          padding: '0px 0px 12px !important',
        }}>
          <DialogContentText variant="p" color="primary" sx={{
            padding: '0px 0px 0px',
          }}>
            {getText("payCancelText")}
          </DialogContentText>
        </DialogContent>
        <DialogActions >
          <Button
            sx={{
              margin: '0 0 0 0',
            }}
            fullWidth variant="contained" size="large" color="primary" onClick={cancelOrder}>
            {getText("payCancelBtnAgree")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

  )
}